import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useForm } from 'react-hook-form';
import { Box, ConfirmationModal, TextField, useOverlayContext } from 'seagull';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { ServerError } from '~/infra/ErrorResponse';
import { handleRequest } from '~/infra/utils';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import styles from './RenameAPIKeyModal.module.scss';
export const RenameAPIKeyModal = (param)=>{
    let { apiKey, dismissModal, getIsNameValid, refresh } = param;
    const { t: apiKeysPageTexts } = useLocaleKeys('pages.apiKeysPage');
    const { t: commonTexts } = useLocaleKeys('common');
    const overlayContext = useOverlayContext();
    const { api } = useStoreActions();
    const { control, handleSubmit } = useForm({
        mode: 'all',
        defaultValues: {
            apiKeyName: apiKey.name
        }
    });
    const onSubmit = handleSubmit(async (param)=>{
        let { apiKeyName } = param;
        if (apiKeyName === apiKey.name) {
            dismissModal();
            return;
        }
        const { success, error } = await handleRequest(api.business.renameAPIKey({
            id: apiKey.id,
            newName: apiKeyName
        }));
        if (!success) {
            const errorText = getRenameAPIKeyErrorText(error);
            overlayContext.showErrorToast(errorText, 'rename-api-key-error');
            return;
        }
        await refresh();
        dismissModal();
    });
    const getRenameAPIKeyErrorText = (error)=>{
        if (error.hasServerError(ServerError.APIKeyNotFound)) {
            return apiKeysPageTexts.keyNoLongerExists();
        }
        if (error.hasServerError(ServerError.APIKeyRenameFailed)) {
            return apiKeysPageTexts.apiKeyNameAlreadyExists();
        }
        return commonTexts.toasts.failedToRenameApiKey();
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'rename_a_p_i_key_confirm'
            },
            secondaryButton: {
                name: 'rename_a_p_i_key_cancel'
            }
        },
        title: apiKeysPageTexts.renameTitle(),
        testId: "rename-api-key-modal",
        width: "640px",
        content: /*#__PURE__*/ _jsx(Controller, {
            control: control,
            name: "apiKeyName",
            rules: {
                required: apiKeysPageTexts.apiKeyNameRequired(),
                validate: (value)=>{
                    if (!value.trim()) return true;
                    return getIsNameValid(value) || apiKeysPageTexts.apiKeyNameAlreadyExists();
                }
            },
            render: (props)=>{
                const _connectControllerToTextField = connectControllerToTextField(props), { error, helperText } = _connectControllerToTextField, rest = _object_without_properties(_connectControllerToTextField, [
                    "error",
                    "helperText"
                ]);
                return /*#__PURE__*/ _jsx(Box, {
                    className: styles.renameApiKeyModalContent,
                    children: /*#__PURE__*/ _jsx(TextField, _object_spread({
                        bi: {
                            name: 'api_key_rename'
                        },
                        collapseHelperText: false,
                        label: apiKeysPageTexts.apiKeyNameLabel(),
                        testId: "api-key-name",
                        autoFocus: true,
                        error: error,
                        helperText: helperText
                    }, rest))
                });
            }
        }),
        primaryButtonLabel: commonTexts.buttons.rename(),
        onPrimaryButtonClick: onSubmit,
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        onSecondaryButtonClick: dismissModal
    });
};
